<ng-container *ngIf="filter">
	<span>{{ filter.label }}</span>
	<div class="filter-container" *ngFor="let item of filter.getValues(); let idx = index; trackBy: trackByFunc">
		<button *ngIf="!isDefaultFilter" type="button" mat-icon-button class="circle-icon-remove" (click)="removeValue(idx)"><mat-icon color="accent" svgIcon="md:remove"
		></mat-icon></button>
		<mat-form-field appearance="outline" class="mat-form-field-custom-width copo-no-error-message" subscriptSizing="dynamic">
			<input matInput [placeholder]="filter.placeholder" [ngModel]="filter.getValues()[idx]" (ngModelChange)="filter.getValues()[idx] = $event" [attr.aria-label]="filter.label" />
		</mat-form-field>
	</div>
</ng-container>
